export default {
  common: {
    regionZone: "Región/Zona",
    seller: "Vendedor",
    chillerOrPlant: "Objetivo",
    dateRange: "Rango de fechas",
    showNumber: "Mostrar número",
    hallOfFame: "Salón de la Fama",
    statisticChart: "Gráfico estadístico",
    win: "Ganar",
    pipeline: "Pipeline",

    chillerAndChillerPlant: "Chiller y planta de enfriamiento",
    chiller: "enfriador",
    chillerPlant: "Planta de enfriamiento",

    ChillerRetrofit: "Reforma de enfriadora",
    ChillerPlantRetrofit: "Reforma de planta de enfriadoras",
    HeatingElectricRetrofit: "Caldera a bomba de calor retrofit",

    heating: "Calefacción",

    regions: "Región",
    zones: "Zona",

    resetPipelineCheckMesg:
      "El sistema está a punto de reemplazar los datos de la instantánea del mes pasado con los datos de la tubería actual. Esta operación es irreversible.  ¿Estás seguro de que quieres realizar esta operación?",
    resetPipeline: "Restablecer la tubería",
    resetLastMonthPipelinedata: "Restablecer los datos del pipeline del mes pasado",

    verificationCode: "Código de verificación",
    enterVerificationCode: "Introduzca el código de verificación para confirmar su operación",
    verificationCodeError: "El código de verificación es un error",

    note: "Nota",
    dataBefore202601: "Los datos para enero de 2026 y anteriores son de la versión 1.0 y actualmente no admiten consultas condicionales para 'estado del proyecto' y 'objetivos del proyecto'.",
    iKnowThis: "Cerrar",

    availableWhen202602: "Disponible desde febrero de 2026 en adelante"
  }
}



// WEBPACK FOOTER //
// ./src/locale/dashboard/es.js